/**
 * Shift-event types that are recorded for engineering diagnostics only and must
 * never render in the customer-facing shift transcript.
 *
 * feat-295-on-device-connection-diagnostics: the Flutter app uploads its on-device
 * connection log as `device_diag` frames over /ws/audio, which the backend saves
 * as shift_event rows like any other JSON frame. Engineers read them with SQL.
 */
export const HIDDEN_SHIFT_EVENT_TYPES: ReadonlySet<string> = new Set(['device_diag']);

export function visibleShiftEvents<T extends { event_type: string }>(events: T[]): T[] {
  return events.filter((e) => !HIDDEN_SHIFT_EVENT_TYPES.has(e.event_type));
}
